export default __webpack_public_path__ + "static/c-and-cpp-development-featured-image-1623409491872fea2b373020b8345f86.jpg";